import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('topeak_token') || '',
    user: JSON.parse(localStorage.getItem('topeak_user') || 'null')
  },
  getters: {
    isAuthenticated: state => !!state.token
  },
  mutations: {
    setAuth(state, payload) {
      if (payload) {
        state.token = payload.token
        state.user = payload.user
        localStorage.setItem('topeak_token', payload.token)
        localStorage.setItem('topeak_user', JSON.stringify(payload.user))
      } else {
        // 清除认证状态
        state.token = ''
        state.user = null
        localStorage.removeItem('topeak_token')
        localStorage.removeItem('topeak_user')
      }
    },
    clearAuth(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem('topeak_token')
      localStorage.removeItem('topeak_user')
    }
  },
  actions: {
    logout({ commit }) {
      commit('clearAuth')
    }
  },
  modules: {
  }
})
